import { Icons } from '../../utilities';
import {
  MAGNET_CATEGORY,
  STICKER_CATEGORY
} from '../../utilities/constants/Constants';

export class Store {
  constructor(data) {
    this.accountId = data.account_id;
    this.adobeStockSubscriptionPrice = data.adobe_stock_subscription_price;
    this.allowFixedSize = data.allowFixed_size;
    this.allowCustomSizeInPreset = data.allow_custom_size_in_preset;
    this.allowSharingAdobeStockCredentials =
      data.allow_sharing_adobe_stock_credentials;
    this.allowSharingDreamstimeCredentials =
      data.allow_sharing_dreamstime_credentials;
    this.allowSharingFotoliaCredentials =
      data.allow_sharing_fotolia_credentials;
    this.allowSharingGettyImagesCredentials =
      data.allow_sharing_getty_images_credentials;
    this.allowSharingIstockCredentials = data.allow_sharing_istock_credentials;
    this.allowSharingPatternDesignCredentials =
      data.allow_sharing_pattern_design_credentials;
    this.allowSharingVecteezyCredentials =
      data.allow_sharing_vecteezy_credentials;
    this.allowVariableSize = data.allow_variable_size;
    this.allowWatermarkSettings = data.allow_watermark_settings;
    this.basePricePerAdobeStockImage = data.base_price_per_adobe_stock_image;
    this.basePricePerDreamstimeImage = data.base_price_per_dreamstime_image;
    this.basePricePerFotoliaImage = data.base_price_per_fotolia_image;
    this.basePricePerGettyImage = data.base_price_per_getty_image;
    this.basePricePerIstockImage = data.base_price_per_istock_image;
    this.basePricePerVecteezyImage = data.base_price_per_vecteezy_image;
    this.cacheTimestamp = data.cache_timestamp;
    this.canvasFrameColor = data.canvas_frame_color;
    this.canvasFrameType = data.canvas_frame_type;
    this.canvasSupport = data.canvas_support;
    this.companyName = data.company_name;
    this.contentHostingSite = data.content_hosting_site;
    this.contentToken = data.content_token;
    this.conversionUnitEur = data.conversion_unit_eur;
    this.conversionUnitUsd = data.conversion_unit_usd;
    this.customGrommets = data.custom_grommets;
    this.customerSupportDescription = data.customer_support_description;
    this.cutoutMaxDimension = data.cutout_max_dimension;
    this.cutoutSupport = data.cutout_support;
    this.defaultLanguage = data.default_language;
    this.defaultPricePerSqft = data.default_price_per_sqft;
    this.defaultViewingDistance = data.default_viewing_distance;
    this.defaultWallColor = data.default_wall_color;
    this.demoMode = data.demo_mode;
    this.designerCustomSizeIcon = data.designer_custom_size_icon;
    this.designerLandscapeIconUrl = data.designer_landscape_icon_url;
    this.designerPortraitIconUrl = data.designer_portrait_icon_url;
    this.displaySize = data.display_size;
    this.displayTaxInfo = data.display_tax_info;
    this.eCommerceServicesUrl = data.e_commerce_services_url;
    this.eCommerceSiteDeleted = data.e_commerce_site_deleted;
    this.enableBlockchain_qrCode = data.enable_blockchain_qr_code;
    this.enableTasteSelector = data.enable_taste_selector;
    this.enableOpenAi = data.enable_open_ai;
    this.externalContentSite = data.external_content_site;
    this.extraInfoMandatory = data.extra_info_mandatory;
    this.fotoliaSubscriptionImagePrice = data.fotolia_subscription_image_price;
    this.genericSampleUrl = data.generic_sample_url;
    this.gettyImagesSubscriptionPrice = data.getty_images_subscription_price;
    this.hasLitePartnerPrinter = data.has_lite_partner_printer;
    this.hideHelp = data.hide_help;
    this.hidePricing = data.hide_pricing;
    this.hideRuler = data.hide_ruler;
    this.hideTemplates = data.hide_templates;
    this.hideWallColorSetting = data.hide_wall_color_setting;
    this.hideWatermark = data.hide_watermark;
    this.hideWeblinkSaveDialog = data.hide_weblink_save_dialog;
    this.homeUrl = data.home_url;
    this.iconUrl = data.icon_url;
    this.id = data.id;
    this.includeWallartContent = data.include_wallart_content;
    this.includeWallartContentExternalContent =
      data.include_wallartContent_external_content;
    this.internalName = data.internal_name;
    this.isHpStore = data.is_hp_store;
    this.istockImageBasePrice = data.istock_image_base_price;
    this.istockSubscriptionPrice = data.istock_subscription_price;
    this.launchWithBackground = data.launch_with_background;
    this.lengthUnitSystem = data.length_unit_system;
    this.licenseType = data.license_type;
    this.localizationSupport = data.localization_support;
    this.maxCustomHeightImperial = data.max_custom_height_imperial;
    this.maxCustomHeightMetric = data.max_custom_height_metric;
    this.maxCustomWidthImperial = data.max_custom_width_imperial;
    this.maxCustomWidthMetric = data.max_custom_width_metric;
    this.minCustomHeightImperial = data.min_custom_height_imperial;
    this.minCustomHeightMetric = data.min_custom_height_metric;
    this.minCustomWidthImperial = data.min_custom_width_imperial;
    this.minCustomWidthMetric = data.min_custom_width_metric;
    this.minOrderAmount = data.min_order_amount;
    this.minimumViewingDistance = data.minimum_viewing_distance;
    this.msrpBase = data.msrp_base;
    this.msrpCurrency = data.msrp_currency;
    this.msrpPerSqft = data.msrp_per_sqft;
    this.name = data.name;
    this.orderExpirationLimit = data.order_expiration_limit;
    this.partnerStoreType = data.partner_store_type;
    this.placeMsrpCurrency = data.place_msrp_currency;
    this.printDpi = data.print_dpi;
    this.productDescription = data.product_description;
    this.productIconUrl = data.product_icon_url;
    this.repositionableposterSupport = data.repositionableposter_support;
    this.requestForQuotation = data.request_for_quotation;
    this.roundupPrice = data.roundup_price;
    this.sampleType = data.sample_type;
    this.sampleWindowHeight = data.sample_window_height;
    this.sampleWindowWidth = data.sample_window_width;
    this.showFeedback = data.show_feedback;
    this.showPlaceablesName = data.show_placeables_name;
    this.showPrice = data.show_price;
    this.sizeChangeWarning = data.size_change_warning;
    this.storeCacheTimestamp = data.store_cache_timestamp;
    this.supportedThemeIds = data.supported_theme_ids;
    this.supportsAdobeStock = data.supports_adobe_stock;
    this.supportsDesignerSettings = data.supports_designer_settings;
    this.supportsDreamstime = data.supports_dreamstime;
    this.supportsDropbox = data.supports_dropbox;
    this.supportsFotolia = data.supports_fotolia;
    this.supportsGettyImages = data.supports_getty_images;
    this.supportsHpMosaic = data.supports_hp_mosaic;
    this.supportsInstagram = data.supports_instagram;
    this.supportsIstock = data.supports_istock;
    this.supportsPatternDesign = data.supports_pattern_design;
    this.supportsPreview = data.supports_preview;
    this.supportsRoomLayout = data.supports_room_layout;
    this.supportsRoomSize = data.supports_room_size;
    this.supportsSample = data.supports_sample;
    this.supportsShare = data.supports_share;
    this.supportsUnsplash = data.supports_unsplash;
    this.supportsUserPhotoUpload = data.supports_user_photo_upload;
    this.supportsVecteezy = data.supports_vecteezy;
    this.taxType = data.tax_type;
    this.title = data.title;
    this.uploadedImageSupRes = data.uploaded_image_sup_res;
    this.useOwnContent = data.use_own_content;
    this.variableSizeType = data.variable_size_type;
    this.wallcoveringSupport = data.wallcovering_support;
    this.vat = data.vat;
    this.wallposterSupport = data.wallposter_support;
    this.warnMessageOnPixelation = data.warn_message_on_pixelation;
    this.warnOnBackgroundScale = data.warn_on_background_scale;
    this.yourPriceBase = data.your_price_base;
    this.yourPriceCurrency = data.your_price_currency;
    this.yourPricePerSqft = data.your_price_per_sqft;
    this.supportEditApplicationGroupName =
      data.support_edit_application_group_name;
    this.applicationGroupCustomName = data.application_group_custom_name;
    this.applicationGroupName = data.application_group_name;
    this.templatePreference = data.template_preference;
    this.fixedSizes = initProjectSizes(data.fixed_sizes);
    this.presetSizes = initProjectSizes(data.preset_sizes);
    this.materials = initMaterials(data.materials);
    this.commonSetting = initCommonSettings(data.common_setting);

    if (data.application_group_settings) {
      const groupSettings = new ProductSetting(data.application_group_settings);
      updateStoreWithProductSettings(this, groupSettings);
    }
    updateStoreWithSupportedProducts(this, data.supported_products);
  }
}

const initMaterials = materials => {
  const materialArray = [];
  if (materials) {
    materials.forEach(material => {
      const materialObj = new Material(material);
      materialArray.push(materialObj);
    });
  }
  return materialArray;
};

const initProjectSizes = fixedSizes => {
  const newArray = [];
  if (fixedSizes) {
    fixedSizes.forEach(fixedSize => {
      // In preset sizes if width and height are set as 0 then do not show it. It will have id value hence the check.
      // If id is 0 means it is coming from custom . Do not validate that
      if (fixedSize.id != 0 && fixedSize.width != 0 && fixedSize.height != 0) {
        const sizeObj = new ProjectSize(fixedSize);
        newArray.push(sizeObj);
      }
    });
  }
  return newArray;
};

const initCommonSettings = setting => {
  const settings = {
    bottomBarColor: setting.bottom_bar_color,
    contentAreaColor: setting.content_area_color,
    copyrightsAreaColor: setting.copyrights_area_color,
    copyrightsFontColor: setting.copyrights_font_color,
    largerLogoUrl: setting.larger_logo_url,
    logoAreaColor: setting.logo_area_color,
    mainButtonsColor: setting.main_buttons_color,
    topBarColor: setting.top_bar_color,
    useDefaultColors: setting.use_default_colors,
    useLargerLogo: setting.use_larger_logo
  };
  return settings;
};

export const updateStoreWithSupportedProducts = (
  storeObj,
  supportedProducts
) => {
  const productArray = [];
  if (supportedProducts) {
    supportedProducts.forEach(product => {
      const productObj = new SupportedProduct(product);
      productArray.push(productObj);
    });
  }
  storeObj.supportedProducts = productArray;
};

export const updateStoreWithProductSettings = (storeObj, settings) => {
  if (settings) {
    Object.assign(storeObj, settings);
  }
};

export class Material {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.finishing = data.finishing;
    this.description = data.description;
    this.pricePerSqft = data.price_per_sqft;
    this.pricePerSqm = data.price_per_sqm;
    this.default = data.default;
    this.thumbnail = data.thumbnail;
    this.deleted = data.deleted;
  }
}

export class ProjectSize {
  constructor(data) {
    this.width = data.width;
    this.height = data.height;
    this.widthMetric = data.width_metric;
    this.heightMetric = data.height_metric;
    this.id = data.id;
    this.name = data.name;
  }
}

export class SupportedProduct {
  constructor(data) {
    this.productId = data.product_id;
    this.name = data.name;
    this.fullwrapSupport = data.fullwrap_support;
    this.dlIntensity = data.dl_intensity;
    this.flIntensity = data.fl_intensity;
    this.alIntensity = data.al_intensity;
    this.camPosX = data.cam_pos_x;
    this.camPosY = data.cam_pos_y;
    this.camPosZ = data.cam_pos_z;
    this.rotatable = data.rotatable;
    this.fullwrapTemplates = data.fullwrap_templates;
    this.category = data.category;
    this.threeDRendering = data.three_d_rendering;
    this.host = data.host;
    this.laptopFamily = data.laptop_family;
    this.threeDEditorUrl = data.three_d_editorUrl;
    this.threeDPreviewUrl = data.three_d_preview_url;
    this.enabled = data.enabled;
    this.constraintType = data.constraint_type;
    this.sku = data.sku;
    this.timestamp = data.timestamp;
    this.groupType = data.group_type;
    this.modelNumber = data.model_number;
    this.invoiceCode = data.invoice_code;
    this.productIconUrl = data.product_icon_url;
    if (data.category == STICKER_CATEGORY) {
      this.overrideIconUrl = Icons.stickersAppIcon;
    }
    if (data.category == MAGNET_CATEGORY) {
      this.overrideIconUrl = Icons.magnetsAppIcon;
    }
    this.designeroptions = data.designer_options;
    if (data.settings && data.settings.length > 0) {
      this.settings = new ProductSetting(data.settings[0]);
    }
    if (data.product_sizes) {
      const productSizesArray = [];
      data.product_sizes.forEach(productSizes => {
        const productSizesObj = new ProductSizes(productSizes);
        productSizesArray.push(productSizesObj);
      });
      this.productSizes = productSizesArray;
    }

    this.activeProductSize = null;
  }
}

export class ProductSizes {
  constructor(data) {
    this.id = data.id;
    this.instance = data.instance;
    this.name = data.name;
    this.aspectRatio = data.aspect_ratio;

    if (data.templates) {
      const templatesArray = [];
      data.templates.forEach(template => {
        const templateObj = new Template(template);
        templatesArray.push(templateObj);
      });
      this.templates = templatesArray;
    }
    this.activeTemplate = null;
  }
}

export class Template {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.material = data.material;
    this.scaleU = data.scale_u;
    this.scaleV = data.scale_v;
    this.offsetU = data.offset_u;
    this.offsetV = data.offset_v;
    this.fullwrap = data.fullwrap;
    this.imageUrl = data.image_url;
    this.imageThumbnailUrl = data.image_thumbnail_url;
    this.previewImageUrl = data.preview_image_url;
    this.overlayImageUrl = data.overlay_image_url;
    this.width = data.width;
    this.height = data.height;
  }
}

export class ProductSetting {
  constructor(data) {
    this.defaultWallColor = data.default_wall_color;
    this.warnOnBackgroundScale = data.warn_on_background_scale;
    this.defaultViewingDistance = data.default_viewing_distance;
    this.supportsSample = data.supports_sample;
    this.supportsRoomSize = data.supports_room_size;
    this.supportsPreview = data.supports_preview;
    this.supportsRoomLayout = data.supports_room_layout;
    this.supportsShare = data.supports_share;
    this.supportsDesignerSettings = data.supports_designer_settings;
    this.hideWallColorSetting = data.hide_wall_color_setting;
    this.defaultPricePerSqft = data.default_price_per_sqft;
    this.hideHelp = data.hide_help;
    this.supportsAdobeStock = data.supports_adobe_stock;
    this.supportsDreamstime = data.supports_dreamstime;
    this.supportsDropbox = data.supports_dropbox;
    this.supportsFotolia = data.supports_fotolia;
    this.supportsGettyImages = data.supports_getty_images;
    this.supportsHpMosaic = data.supports_hp_mosaic;
    this.supportsInstagram = data.supports_instagram;
    this.supportsIstock = data.supports_istock;
    this.supportsPatternDesign = data.supports_pattern_design;
    this.supportsUnsplash = data.supports_unsplash;
    this.supportsUserPhotoUpload = data.supports_user_photo_upload;
    this.supportsVecteezy = data.supports_vecteezy;
    this.requestForQuotation = data.request_for_quotation;
    this.allowVariableSize = data.allow_variable_size;
    this.allowCustomSizeInPreset = data.allow_custom_size_in_preset;
    this.allowFixedSize = data.allow_fixed_size;
    this.variableSizeType = data.variable_size_type;
    this.productIconUrl = data.product_icon_url;
    this.designerPortraitIconUrl = data.designer_portrait_icon_url;
    this.designerLandscapeIconUrl = data.designer_landscape_icon_url;
    this.designerCustomSizeIcon = data.designer_custom_size_icon;
    this.customGrommets = data.custom_grommets;
    this.hidePricing = data.hide_pricing;
    this.minOrderAmount = data.min_order_amount;
    this.hideWatermark = data.hide_watermark;
    this.displaySize = data.display_size;
    this.sizeChangeWarning = data.size_change_warning;
    this.warnMessageOnPixelation = data.warn_message_on_pixelation;
    this.hideRuler = data.hide_ruler;
    this.maxCustomHeightImperial = data.max_custom_height_imperial;
    this.maxCustomHeightMetric = data.max_custom_height_metric;
    this.maxCustomWidthImperial = data.max_custom_width_imperial;
    this.maxCustomWidthMetric = data.max_custom_width_metric;
    this.minCustomHeightImperial = data.min_custom_height_imperial;
    this.minCustomHeightMetric = data.min_custom_height_metric;
    this.minCustomWidthImperial = data.min_custom_width_imperial;
    this.minCustomWidthMetric = data.min_custom_width_metric;

    this.fixedSizes = initProjectSizes(data.fixed_sizes);
    this.presetSizes = initProjectSizes(data.preset_sizes);
    this.materials = initMaterials(data.materials);
  }
}
